import { render } from "./about-nolido.vue?vue&type=template&id=414d2a3b&scoped=true"
import script from "./about-nolido.vue?vue&type=script&lang=js"
export * from "./about-nolido.vue?vue&type=script&lang=js"

import "./about-nolido.vue?vue&type=style&index=0&id=414d2a3b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-414d2a3b"]])

export default __exports__